import { render, staticRenderFns } from "./thematicAreaReportPO.vue?vue&type=template&id=230c12fa&scoped=true"
import script from "./thematicAreaReportPO.vue?vue&type=script&lang=js"
export * from "./thematicAreaReportPO.vue?vue&type=script&lang=js"
import style0 from "./thematicAreaReportPO.vue?vue&type=style&index=0&id=230c12fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230c12fa",
  null
  
)

export default component.exports